import React, { useState, useEffect } from 'react';
import './App.css';
import InstagramEmbed from "react-instagram-embed";
import "./InstagramLoader.jsx";
import Instagram from './Instagram';


import Post from "./Post";
import { db, auth } from "./firebase";
import Modal from '@material-ui/core/Modal';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Input, IconButton } from '@material-ui/core';
import ImageUpload from "./ImageUpload";
import "./style.css";
import HomeIcon from '@material-ui/icons/Home';
import SendRoundedIcon from '@material-ui/icons/SendRounded';
import ExploreOutlinedIcon from '@material-ui/icons/ExploreOutlined';
import FavoriteBorderRoundedIcon from '@material-ui/icons/FavoriteBorderRounded';
import Footer from "./Footer";

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

function App() {

  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);

  const [posts, setPosts] = useState([]);
  const [open, setOpen] = useState(false);
  const [openSignIn, setOpenSignIn] = useState(false);

  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [user, setUser] = useState(null);

  const [embeds, setEmbeds] = useState('');

  // https://www.instagram.com/p/CGDFuRiHled/
  // https://www.instagram.com/p/CFNq2J_g4Bf/

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((authUser) => {
      if (authUser) {
        // user logged in
        // console.log(authUser);
        setUser(authUser);

        // if (authUser.displayName) {
        // don't update username
        // } else {
        // if new user is just created
        //   return authUser.updateProfile({
        //     displayName: username,
        //   });
        // }

      } else {
        // user logged out
        setUser(null);
      }

    })
    return () => {
      // perform clean action before firing next useEffect and cluttering the DOM
      unsubscribe();
    }

  }, [user, username]);
  // parameter cannot be empty because variable 


  useEffect(() => {
    db.collection('posts').orderBy('timestamp', 'desc').onSnapshot(snapshot => {
      setPosts(snapshot.docs.map(doc => ({
        id: doc.id,
        post: doc.data()
      })));
    })

  }, [])
  // run code inside once when posts change [post is  a dependency]

  useEffect(() => {


    async function fetchData() {
      const fr = db.collection('side_embed').doc('WhIOmGP0bPtHMCbVJrh4')
      const doc = await fr.get();
      // const request = await axios.get(selectedOption);
      if (!doc.exists) {
        console.log('No such document!');
      } else {
        console.log('Document data:', doc.data());
        // console.log(doc.data);
        const link = doc.data().link;
        console.log('LINK>>>', link);
        setEmbeds(link);
      }
      return doc;
    }
    fetchData();

    // setEmbeds(snapshot.docs.map(doc => (
    //   { embed: doc.link }
    // )));
    // console.log(embed);
  }
    , [])

  // async function getDocument(db) {
  //   const cityRef = db.collection('side_embed');
  //   const doc = await cityRef.get();
  //   if (!doc.exists) {
  //     console.log('No such document!');
  //   } else {
  //     console.log('Document data:', doc.data());
  //   }
  // }
  // getDocument(db);

  const signUp = (event) => {
    event.preventDefault();

    auth
      .createUserWithEmailAndPassword(email, password)
      .then((authUser) => {
        return authUser.user.updateProfile({
          displayName: username
        })
      })
      .catch((error) => alert(error.message));

    setOpen(false);
  }

  const signIn = (event) => {
    event.preventDefault();
    auth
      .signInWithEmailAndPassword(email, password)
      .catch((error) => alert(error.message))

    setOpenSignIn(false);
  }





  return (
    <div className="app" >

      <Instagram />

      <Modal
        open={open}
        onClose={() => setOpen(false)}
      >
        <div style={modalStyle} className={classes.paper}>
          <form className="app__signUp">

            <center>
              <img
                className="app__modalLogo"
                // src="https://fontmeme.com/permalink/201002/14e0d14364bfabe49964d49a02c5693d.png"
                src="https://fontmeme.com/permalink/201002/a9e3641dbeb692445856c2aef9ec4c46.png"
                alt=""
              />
            </center>

            <Input
              placeholder="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />

            <Input
              placeholder="email"
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <Input
              placeholder="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <Button type="submit" onClick={signUp}>Sign Up</Button>

          </form>
        </div>
      </Modal>



      <Modal
        open={openSignIn}
        onClose={() => setOpenSignIn(false)}
      >
        <div style={modalStyle} className={classes.paper}>
          <form className="app__signIn">

            <center>
              <img
                className="app__modalLogo"
                // src="https://fontmeme.com/permalink/201002/14e0d14364bfabe49964d49a02c5693d.png"
                src="https://fontmeme.com/permalink/201002/a9e3641dbeb692445856c2aef9ec4c46.png"
                alt=""
              />
            </center>

            <Input
              placeholder="email"
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <Input
              placeholder="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <Button type="submit" onClick={signIn}>Log In</Button>

          </form>
        </div>
      </Modal>


      {/* Header */}
      <div className="app__header" >
        <img
          className="app__headerImage"
          // src="https://fontmeme.com/permalink/201002/14e0d14364bfabe49964d49a02c5693d.png"
          src="https://fontmeme.com/permalink/201002/a9e3641dbeb692445856c2aef9ec4c46.png"
          alt=""
        />
        {user ? (
          <>
            < div className="app__loginContainer">
              <IconButton>
                <HomeIcon />
              </IconButton>
              <IconButton>
                <SendRoundedIcon />
              </IconButton>
              <IconButton>
                <ExploreOutlinedIcon />
              </IconButton>
              <IconButton>
                <FavoriteBorderRoundedIcon />
              </IconButton>


              <Button onClick={() => auth.signOut()}>Log Out</Button>
            </div>
          </>
        ) : (
            <div className="app__loginContainer">

              {/* <HomeIcon />
              <SendRoundedIcon />
              <ExploreOutlinedIcon />
              <FavoriteBorderRoundedIcon /> */}

              <Button onClick={() => setOpenSignIn(true)}>Log In</Button>
              <Button onClick={() => setOpen(true)}>Sign Up</Button>
            </div>

          )
        }
      </div >


      {/* Caption Input + File Picker + Post Button */}
      {
        user?.displayName ? (
          <>
            {/* <div className="app__avatars">
              <Avatar src="https://images.pexels.com/photos/3990562/pexels-photo-3990562.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500" />
              <Avatar src="https://images.pexels.com/photos/3990562/pexels-photo-3990562.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500" />
              <Avatar src="https://images.pexels.com/photos/3990562/pexels-photo-3990562.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500" />
              <Avatar src="https://images.pexels.com/photos/3990562/pexels-photo-3990562.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500" />
              <Avatar src="https://images.pexels.com/photos/3990562/pexels-photo-3990562.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500" />
              <Avatar src="https://images.pexels.com/photos/3990562/pexels-photo-3990562.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500" />

            </div> */}
            <ImageUpload username={user.displayName} />
          </>
        ) : (
            <h3 className="app__info"> Login to Post your Photos and Comment</h3>
          )
      }


      <div className="app__posts">

        <div className="app__postsLeft">


          {/* Posts */}

          {posts.map(({ id, post }) => (
            <Post key={id} postId={id} user={user} imageUrl={post.imageUrl} username={post.username} caption={post.caption} />
          ))
          }
        </div>


        <div className="app__postsRight">



          <InstagramEmbed

            url='https://www.instagram.com/p/CFNq2J_g4Bf/'

            maxWidth={300}
            hideCaption={false}
            containerTagName='div'
            protocol=''
            injectScript
            // onLoading={() => { }}
            // onSuccess={() => { }}
            // onAfterRender={() => { }}
            // onFailure={() => { }}
            onLoading={() => { console.log('loading') }}
            onSuccess={() => { console.log('loaded') }}
            onAfterRender={() => { console.log('rendered') }}
            onFailure={() => { console.log('failed') }}

          />

        </div>


      </div>

      <Footer />
      <Instagram />
    </div >
  );
}

export default App;
